import React from 'react'

interface ValidationMessageHelperProps {
  originValidated: boolean
  quantityValidated: boolean
  destinyValidated: boolean
  requiresComments: boolean
  documentNumber?: string
  observations?: string
}

export const ValidationMessageHelper: React.FC<ValidationMessageHelperProps> = ({
  originValidated,
  quantityValidated,
  destinyValidated,
  requiresComments,
  documentNumber,
  observations
}) => {
  if (!originValidated) {
    return <React.Fragment>Valide la posición de origen</React.Fragment>
  }

  if (!quantityValidated) {
    return <React.Fragment>Valide la cantidad a reubicar</React.Fragment>
  }

  if (!destinyValidated) {
    return <React.Fragment>Valide la posición de destino</React.Fragment>
  }

  if (
    requiresComments &&
    (!documentNumber?.trim() || !observations?.trim())
  ) {
    return <React.Fragment>Complete la información requerida</React.Fragment>
  }

  return null
}
